const  rules = {
                newName: [
                    { required: true, message: 'First Name is required', trigger: 'blur' }
                ],
                 email: [
                    { required: true, message: 'Email Address is required', trigger: 'blur' },
                    {
                    type: 'email',
                    message: 'Please input a valid email address',
                    trigger: 'blur'
                    },
                    {
                    pattern: /^([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
                    message: 'Please input a valid email address format',
                    trigger: 'blur'
                    }
                ],
                phone: [
                    { required: true, message: 'Phone is required', trigger: 'blur' },
                    {
                    pattern: /^\+?[1-9]\d{1,14}$/,
                    message: 'Phone must be a valid number',
                    trigger: 'blur'
                    }
                ],
                // arrivalDate: [
                //     { required: true, message: 'Arrival Date is required', trigger: 'blur' }
                // ],
                // departureDate: [
                //     { required: true, message: 'Departure Date is required', trigger: 'blur' }
                // ],
            //    adults: [
            //         { required: true, message: 'Adults number is required', trigger: 'blur' },
            //         {   pattern: /^[1-9]\d*$/,
            //             message: 'Adults must be a number',
            //             trigger: 'blur' 
            //         }
            //     ],
            //     child: [
            //         { required: true, message: 'Children number is required', trigger: 'blur' },
            //         { 
            //             pattern: /^[1-9]\d*$/,
            //             message: 'Children must be a number',
            //             trigger: 'blur' 
            //         }
            //     ],
                days: [
                    { required: true, message: 'Days number is required', trigger: 'change' },
                  ],
                grade: [
                    { required: true, message: 'Grade is required', trigger: 'change' },
                ]
            }
export default {
    rules
}